import dayjs from "dayjs";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { LineBoxContainer } from "../../../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import CalendarModal from "../../../../Modal/CalendarModal";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import {
  sunsetDetailDataState,
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
} from "./SunsetSubs";

export default function NotifyDate() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );
  const [notifyDate, setNotifyDate] = useState(
    location?.state
      ? dayjs(location?.state?.sunsetData?.notifyDate).format("YYYY-MM-DD")
      : "날짜 선택"
  );
  const [sunsetDateClick, setSunsetDateClick] = useState(false);

  useEffect(() => {
    if (notifyDate !== "날짜 선택") {
      setSunsetDetailData({
        ...sunsetDetailData,
        notifyDate: notifyDate,
      });
    }
  }, [notifyDate]);

  useEffect(() => {
    console.log(sunsetDetailData);
  }, [sunsetDetailData]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>일몰 통지일</VerticalTableLabel>

      <LineBoxContainer>
        {buttonType === "view" ? (
          <VerticalTableValue>{notifyDate}</VerticalTableValue>
        ) : (
          <CalendarLineBtn
            onClickEvent={() => setSunsetDateClick(true)}
            value={notifyDate}
            initValue={"날짜 선택"}
            disabled={sunsetDetailData?.sunsetDate === ""}
            minWidth={220}
          />
        )}

        {sunsetDateClick && (
          <CalendarModal
            closeEvent={() => setSunsetDateClick(false)}
            changeEvent={(date: string) => setNotifyDate(date)}
            isFutureDisable={true}
            dateValue={sunsetDetailData?.sunsetDate}
            sPosition="absolute"
          />
        )}
      </LineBoxContainer>
    </VerticalTableRow>
  );
}
